module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.controller) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('forminput', {
    attrs: {
      "controller": _vm.controller.dosageInstruction
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('label', {
    staticClass: "control-label",
    class: {
      'text-danger': _vm.controller.roundsController.hasError, 'text-warning': _vm.controller.roundsController.hasWarning, 'text-success': _vm.controller.roundsController.hasSuccess
    }
  }, [_vm._v("Rounds " + _vm._s(_vm.controller.roundsController.message))]), _vm._v(" "), _c('RoundSelector', {
    attrs: {
      "controller": _vm.controller.roundsController
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', {
    staticClass: "control-label",
    class: {
      'text-danger': _vm.controller.daysOfDosage.hasError, 'text-warning': _vm.controller.daysOfDosage.hasWarning, 'text-success': _vm.controller.daysOfDosage.hasSuccess
    }
  }, [_vm._v("Dosage " + _vm._s(_vm.controller.daysOfDosage.message))]), _vm._v(" "), _c('ScheduleSelector', {
    attrs: {
      "controller": _vm.controller.daysOfDosage,
      "Start-date": _vm.controller.startDate.value
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }), _vm._v(" "), (!_vm.controller.IsUpdating) ? _c('div', {
    staticClass: "row"
  }) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-34ea064e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-34ea064e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/appcontrols/PatientMedProfile2/DispensationItemEditor.scp.html
// module id = 467
// module chunks = 0